import { type ReactNode } from "react";

import { Link as AriaLink, type LinkProps as AriaLinkProps } from "react-aria-components";

import { ExternalLinkIcon } from "#icons";
import { cn } from "#utils";

/** LinkProps interface for the Link component */
export interface LinkProps extends Omit<AriaLinkProps, "className" | "children"> {
  /** Additional CSS class names */
  className?: string;
  /** Show an external link icon to the right of the link text */
  external?: boolean;
  /** Link content */
  children?: ReactNode;
}

/** A styled text link built on react-aria-components Link */
export const Link = (props: LinkProps) => {
  const { className, external, children, ...restProps } = props;

  return (
    <AriaLink
      {...restProps}
      className={cn(
        "cursor-pointer underline outline-none data-[disabled]:cursor-not-allowed",
        "text-interactive-link-enabled hover:text-interactive-link-hover focus:text-interactive-link-focus data-[disabled]:text-interactive-link-disabled",
        external ? "inline-flex items-center gap-1" : undefined,
        className,
      )}
    >
      {children}
      {external ? <ExternalLinkIcon fill="currentColor" size={12} /> : null}
    </AriaLink>
  );
};
